import { createContext } from 'react'

export const SubMenuContext = createContext(null)

export const SubMenuActionsContext = createContext(null)
